import addError from '../../../../utils/error.jsx';

export function request() {
    return {
        type: 'LADDERS_GET_MASTER_REQUEST'
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'LADDERS_GET_MASTER_ERROR',
        errors
    };
}

export function finish({prices}) {
    return {
        type: 'LADDERS_GET_MASTER_FINISH',
        prices
    };
}
